module.exports = __webpack_public_path__ + "images/alfaromeod6f40843c1a48a3c4bc74b2498df2d73.png";